const FooterContent = {
    usefulLinks: {
        en:[{
            name: 'Home',
            dest: '/',
        },{
            name:'Teams',
            dest:'/teams/',
        },{
            name:'Announcements',
            dest:'/news',
        }, {
            name:'Sponsors',
            dest:'/sponsors',
        }],
        el: [{
            name: 'Αρχική',
            dest: '/',
        },{
            name:'Ομάδες',
            dest:'/teams/',
        },{
            name:'Ανακοινώσεις',
            dest:'/news',
        }, {
            name:'Χορηγοί',
            dest:'/sponsors',
        }],
    }
}


export default FooterContent